import React, { useEffect } from 'react';

function Partners() {
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div style={containerStyle}>
      <div style={partnerStyle}>
        <h2>Our Partners - Teepublic</h2>
        <p>We are proud to partner with Teepublic for stickers!</p>
        <p>Teepublic offers a wide range of high-quality stickers for your needs.</p>
        <p>Check out our collection on Teepublic: <a href="https://www.teepublic.com/user/shopbytaha">Teepublic Store</a></p>
      </div>

      <div style={partnerStyle}>
        <h2>Our Partners - Gumroad</h2>
        <p>We are proud to partner with Gumroad for digital products!</p>
        <p>Gumroad provides a platform for creators to sell digital products such as designs, ebooks, and more.</p>
        <p>Explore our collection on Gumroad: <a href="https://tahargriach.gumroad.com/">Gumroad Store</a></p>
      </div>
    </div>
  );
}

const containerStyle = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  flexWrap: 'wrap',
};

const partnerStyle = {
  width: '45%',
  margin: '20px',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#f9f9f9',
};

export default Partners;
